module.exports = __webpack_public_path__ + "img/Gold.f7b78d60.png";